import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';

interface ButtonFont {
  name: string;
  family: string;
}

interface ButtonFontContextType {
  buttonFont: ButtonFont;
  setButtonFont: (font: ButtonFont) => void;
}

const ButtonFontContext = createContext<ButtonFontContextType | undefined>(undefined);

const DEFAULT_BUTTON_FONT: ButtonFont = {
  name: 'Playfair Display',
  family: '"Playfair Display", serif',
};

export const ButtonFontProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [buttonFont, setButtonFont] = useState<ButtonFont>(DEFAULT_BUTTON_FONT);

  // Update CSS variable when font changes
  useEffect(() => {
    document.documentElement.style.setProperty('--button-font-family', buttonFont.family);
  }, [buttonFont]);

  return (
    <ButtonFontContext.Provider value={{ buttonFont, setButtonFont }}>
      {children}
    </ButtonFontContext.Provider>
  );
};

export const useButtonFont = () => {
  const context = useContext(ButtonFontContext);
  if (!context) {
    throw new Error('useButtonFont must be used within ButtonFontProvider');
  }
  return context;
};
